import {useEffect, useState} from 'react';
import {Routes, Route, useNavigate} from 'react-router-dom';
import HomePage from './pages/HomePage';
import MatchPage from './pages/MatchPage';
import FootballPage from './pages/FootballPage';
import ProfilePage from './pages/ProfilePage';
import {UserProvider} from "./pages/UserContext";
import AccessPage from "./pages/AccessRequestPage";
import AdminPage from "./pages/AdminPage";
import HistoryPage from "./pages/HistoryPage";
import ShopPage from "./pages/ShopPage";
import splashStyles from "./designs/HomePage.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const APP_LOCK_POLL_MS = 15000;

const START_PARAM_ROUTES = {
    football: "/football",
    matches: "/football",
};

function TelegramDeepLinkHandler() {
    const navigate = useNavigate();

    useEffect(() => {
        let startParam = "";
        try {
            const telegramStartParam = window?.Telegram?.WebApp?.initDataUnsafe?.start_param;
            const urlStartParam = new URLSearchParams(window.location.search).get("tgWebAppStartParam");
            startParam = String(telegramStartParam || urlStartParam || "").trim().toLowerCase();
        } catch {
            startParam = "";
        }

        const targetRoute = START_PARAM_ROUTES[startParam];
        if (targetRoute) {
            navigate(targetRoute, {replace: true});
        }
    }, [navigate]);

    return null;
}

const getInitDataSafe = () => {
    try {
        return window?.Telegram?.WebApp?.initData || "";
    } catch {
        return "";
    }
};

function AppLoadingScreen() {
    return (
        <div className={splashStyles.splashScreen}>
            <div className={splashStyles.splashGlow}/>
            <div className={splashStyles.splashBrand}>
                <div className={splashStyles.splashCrown}>♛</div>
                <div className={splashStyles.splashFamily}>СІМ'Я</div>
                <div className={splashStyles.splashName}>ГРАЧА</div>
            </div>
            <div className={splashStyles.splashProgress}>
                <span/>
            </div>
            <div className={splashStyles.splashLabel}>Готуємо твою гру</div>
        </div>
    );
}

function AppLockGate({children}) {
    const [checked, setChecked] = useState(false);
    const [locked, setLocked] = useState(false);

    useEffect(() => {
        let cancelled = false;
        let intervalId = null;

        const checkLock = async () => {
            try {
                const API_BASE = process.env.REACT_APP_API_BASE || '/api';
                const res = await fetch(`${API_BASE}/app-lock?_=${Date.now()}`, {
                    cache: "no-store",
                    headers: {
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                        "Pragma": "no-cache",
                        "Expires": "0",
                        "X-Telegram-Init-Data": getInitDataSafe(),
                    },
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                if (!cancelled) setLocked(!!data?.locked);
            } catch (err) {
                console.warn("App lock check failed:", err);
                if (!cancelled) setLocked(false);
            } finally {
                if (!cancelled) setChecked(true);
            }
        };

        checkLock();
        intervalId = window.setInterval(checkLock, APP_LOCK_POLL_MS);
        return () => {
            cancelled = true;
            if (intervalId) window.clearInterval(intervalId);
        };
    }, []);

    if (!checked || locked) return <AppLoadingScreen/>;
    return children;
}

function App() {

    return (
        <UserProvider>
            <TelegramDeepLinkHandler/>
            <AppLockGate>
                <Routes>
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/match" element={<MatchPage/>}/>
                    <Route path="/football" element={<FootballPage/>}/>
                    <Route path="/profile" element={<ProfilePage/>}/>
                    <Route path="/access-request" element={<AccessPage/>}/>
                    <Route path="/admin" element={<AdminPage/>}/>
                    <Route path="/history" element={<HistoryPage/>}/>
                    <Route path="/shop" element={<ShopPage/>}/>
                </Routes>
            </AppLockGate>
        </UserProvider>
    );
}

export default App;
